import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';


import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {setComponentState,setSidebarState} from '../../actions/Builder.js';
import SidebarSettingAccordion from './SidebarSettingAccordion.js';

import SidebarElementSpacing from './SidebarElementSpacing.js';
import LinkPicker from './LinkPicker.js';
import AlignPicker from './AlignPicker.js';
import ColorPicker from './ColorPicker.js';
import BorderPicker from './BorderPicker.js';
import FontPicker from './FontPicker.js';

import PaddingPicker from './PaddingPicker.js';
import SidebarElementWrapper from './SidebarElementWrapper.js';
import SidebarElementSetting from './SidebarElementSetting.js';

import SidebarElementHeader from './SidebarElementHeader.js';

class Cart extends React.Component {
	constructor(props) {	
		super(props);
		this.el = this.el.bind(this);	
		this.handleBackClick = this.handleBackClick.bind(this);

		this.items = this.items.bind(this);
		this.image = this.image.bind(this);
		this.quantity = this.quantity.bind(this);
		this.details = this.details.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onButtonChange = this.onButtonChange.bind(this);
		
	}

	onButtonChange(e) {
		this.props.setComponentState(this.el().id,{'button_text':e.target.value});
	}

	handleChange(id,s) {
		let changes = {};
    	changes[id] = s; 
		this.props.setComponentState(this.el().id,changes);
	}

	el() {
    	return this.props.builder.components[this.props.id];
    }

    handleBackClick() {
    	this.props.setSidebarState({'visible':false});
    }

    items() {
    	let lines = [];
    	const products = [
    		{
    			'id':1,
    			'name':'Product line 1',
    			'description': 'This is the description for product line 1.',
    			'image': 'https://cdn.crall.io/uploads/test.jpg',
    			'quantity': 2
    		},
    		{
    			'id':2,
    			'name':'Product line 2',
    			'description': 'This is the description for product line 2.',
    			'image': 'https://cdn.crall.io/uploads/test.jpg',
    			'quantity': 1
    		}
    	];

    	products.map((item) => {
    		lines.push(
    				<tr key={item.id}>
						<td className="table-width-20 table-top" style={{padding:'5px'}}>
							{this.image(item)}
						</td>
						<td className="table-width-60 table-top" style={{padding:'5px',color:this.el().text_color}}>
							{this.details(item)}
						</td>
						<td className="table-width-20" style={{padding:'5px',color:this.el().text_color}}>
							{this.quantity(item)}
						</td>
					</tr>
    		);
    	});

    	return lines;
    }

    image(item) {
    	return (
    		<table className="table-block">
    			<tbody>
    				<tr>
    					<td>
    						<img src={item.image} style={{maxWidth:'130px'}} />
    					</td>
    				</tr>
    			</tbody>
    		</table>
    	)
    }

    quantity(item) {
    	return (
    		<table className="table-block table-text-center">
				<tbody>
					<tr>
						<td>
							<span style={{fontSize:this.el().text_size,color:this.el().text_color,fontFamily:this.el().text_font}}>x{item.quantity}</span>
						</td>
					</tr>
				</tbody>
			</table>
    	)
    }

    details(item) {
    	return (
    		<table className="table-block table-text-left">
				<tbody>
					<tr>
						<td>
							<span style={{fontSize:this.el().link_size,color:this.el().link_color,fontFamily:this.el().link_font}}>{item.name}</span>
						</td>
					</tr>
					<tr>
						<td>
							<span style={{fontSize:this.el().text_size,color:this.el().text_color,fontFamily:this.el().text_font}}>{item.description}</span>
						</td>
					</tr>
				</tbody>
			</table>
    	)
    }
    

	componentDidMount() {
		
	}

    render() {
    	if(this.props.sidebar == true) {
    		return(
	    		<div className="sidebar text" style={this.props.style}>
	    			<SidebarElementHeader handleBackClick={this.handleBackClick} text="Abandoned cart" />
	    			
	    			<div className="panel-group panel-group-continuous" id="cart-settings" aria-multiselectable="true" role="tablist">


	    				<SidebarSettingAccordion selectedSetting={false} optionKey="container" parent="cart-settings" title="Container">
	                    
							<SidebarElementSetting text="Font style">
								<FontPicker 
									fontId='text_font' 
									sizeId='text_size'
									colorId='text_color'
									font={this.el().text_font} 
									size={this.el().text_size}
									color={this.el().text_color} 
									handleChange={this.handleChange} 
								/>
							</SidebarElementSetting>

	                    </SidebarSettingAccordion>


                        <SidebarSettingAccordion selectedSetting={false} optionKey="link" parent="cart-product" title="Product line">

                            <SidebarElementSetting text="Link font settings">
                                <FontPicker
                                    fontId='link_font'
                                    sizeId='link_size'
                                    colorId='link_color'
                                    font={this.el().link_font}
                                    size={this.el().link_size}
                                    color={this.el().link_color}
                                    handleChange={this.handleChange}
                                />
                            </SidebarElementSetting>



                        </SidebarSettingAccordion>




	                    <SidebarSettingAccordion selectedSetting={false} optionKey="button" parent="cart-settings" title="Button">
    	    				<SidebarElementSetting text="Text">
								<input type="text" value={this.el().button_text} onChange={this.onButtonChange} className="form-control" />
							</SidebarElementSetting>

							<SidebarElementSetting text="Font style">
								<FontPicker 
									fontId='button_font' 
									sizeId='button_size'
									colorId='button_color'
									font={this.el().button_font} 
									size={this.el().button_size}
									color={this.el().button_color} 
									handleChange={this.handleChange} 
								/>
							</SidebarElementSetting>

							<SidebarElementSetting text="Border">
								<BorderPicker id='button_border' handleBorderChange={this.handleChange} data={this.el().button_border} />
							</SidebarElementSetting>

							<SidebarElementSetting text="Background color">
								<ColorPicker id='button_background' color={this.el().button_background} handleColorChange={this.handleChange} />
							</SidebarElementSetting>

							<SidebarElementSetting text="Horizontal position">
								<AlignPicker id="button_align" align={this.el().button_align} handleChange={this.handleChange}/>
							</SidebarElementSetting>

	                    </SidebarSettingAccordion>
	    			</div>

	    			
	    		</div>


    		);
    	}else{
    		let button_style = {fontSize:this.el().button_size,color:this.el().button_color,fontFamily:this.el().button_font,border:this.el().button_border.replace(/\|/g,' '),backgroundColor:this.el().button_background};

    		return (
    			<table className="table-block" style={{width:'100%'}}>
    				<tbody>
    					<tr>
	    					<td style={{padding:this.el().padding}}>
	    						<table className="table-block">
	    							<tbody>
	    								{this.items()}
	    							</tbody>
	    						</table>
	    					</td>
    					</tr>
    					<tr>
    						<td style={{padding:this.el().padding}}>
    							<table className="table-block" style={{width:'100%'}}>
				    				<tbody>
				    					<tr>
					    					<td style={{textAlign:this.el().button_align}}>
					    						<a className="click-button"  style={button_style}  href="javascript:void(0)">{this.el().button_text}</a>
					    					</td>
				    					</tr>
				    				</tbody>
				    			</table>
    						</td>
    					</tr>
    				</tbody>
    			</table>
	      		
	      );
    	}
      
    }
}
const mapStateToProps = (state) => {
	return {
		builder:state.builder
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({setComponentState,setSidebarState},dispatch)
}

Cart = connect(mapStateToProps,mapDispatchToProps)(Cart);

export default Cart;





// WEBPACK FOOTER //
// ./components/builder/Cart.js